import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p382637467424104448',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
